import React from "react";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ContactInformationMultiple from "../ContactInformationMultiple/ContactInformationMultiple";
import OfficeAddress from "../OfficeAddress/OfficeAddress";
import BasicReviserData from "../BasicReviserData/BasicReviserData";
import AuditCompanyMember from "../AuditCompanyMember/AuditCompanyMember";
import AuditCompanyBoardMember from "../AuditCompanyBoardMember/AuditCompanyBoardMember";
import NetworkMembershipInfo from "../NetworkMembershipInfo/NetworkMembershipInfo";
import NamesAndAddressesNetworkList from "../NamesAndAddressesNetworkList/NamesAndAddressesNetworkList";
import NameAndAddressData from "../NameAndAddressData/NameAndAddressData";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import ColDynamic from "../WrapperComponents/ColDynamic";
import Dropdown from "../../UI/Dropdown/Dropdown";
import MappedRegistrationComponent from "../MappedRegistrationComponent/MappedRegistrationComponent";
import "./EntryForm5.css";
import DatepickerComponent from "../../UI/DatePicker/DatepickerComponent";
import { Spinner } from "react-bootstrap";

const EntryForm5 = (props) => {
  const { userData, hqAddress, croAddress, registrationAddress } =
    props.parentState.newFormData;

  const legalFormsOptions = props.parentState.legalForms.map((element) => {
    return (
      <option key={element.sifPOblika} value={element.sifPOblika}>
        {element.opisPOblika}
      </option>
    );
  });

  const { officeAddress } = props.parentState.newFormData;
  const mappedOfficeAddress = officeAddress.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`office-address-collapse${index}`}
        clickText={`Adresa ureda ${
          officeAddress.length > 1 ? `(${index + 1})` : ""
        }`}
      >
        <OfficeAddress
          required
          objData={{ group: "officeAddress" }}
          id={element.id}
          idZaBtn={index}
          {...props}
        ></OfficeAddress>
      </CollapsableWrapper>
    );
  });

  const { basicReviserData } = props.parentState.newFormData;
  const mappedBasicReviserData = basicReviserData.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`basic-rev-data-collapse${index}`}
        clickText={`Ovlašteni revizor ${
          element.ime && element.prezime ? `(${element.ime} ${element.prezime})` : "(Novi unos)"
        }`}
      >
        <BasicReviserData
          group={"basicReviserData"}
          required
          disabled
          id={element.id}
          secId={1}
          idZaBtn={index}
          handleFetch={props.getReviserDataByOib}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const { reviserRegistration } = props.parentState.newFormData;
  const mappedReviserRegistration = reviserRegistration.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`reviser-registration-data-collapse${index}`}
          clickText={`Podaci o glavnom revizijskom partneru koji obavlja zakonsku reviziju u ime revizorskog društva u Republici Hrvatskoj ${
            reviserRegistration.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <BasicReviserData
            hideMultiple
            group={"reviserRegistration"}
            required
            disabled
            id={element.id}
            idZaBtn={index}
            secId={2}
            handleFetch={props.getReviserRegData(element.id)}
            {...props}
          />
        </CollapsableWrapper>
      );
    }
  );

  const { contactInformation } = props.parentState.newFormData;
  const getContactInfo = contactInformation.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`contact-information-${index}-collapse`}
        clickText={`Osoba za kontakt ${
          contactInformation.length > 1 ? `(${index + 1})` : ""
        }`}
      >
        <ContactInformationMultiple
          id={element.id}
          idZaBtn={index}
          {...props}
        ></ContactInformationMultiple>
      </CollapsableWrapper>
    );
  });


  const popuniZagraduAuditCompanyMember = (clan) =>{
    if(clan.oib){
      if(clan.ime && clan.prezime){
        if(clan.naziv) {
          return `(${clan.ime} ${clan.prezime} - ${clan.naziv})`
        }
        return `(${clan.ime} ${clan.prezime})`;
      }else if(clan.naziv){
        return `(${clan.naziv})`;
      }
    }
    return "(Novi unos)";
  }

  const { auditCompanyMember } = props.parentState.newFormData;
  const mappedAuditCompanyMember =
    props.parentState.newFormData.auditCompanyMember.map((element, index) => {
      return (
        <CollapsableWrapper
          key={`audit-company-member${index}-collapse`}
          clickText={`Član/dioničar revizorskog društva ${popuniZagraduAuditCompanyMember(element) }`}
        >
          <AuditCompanyMember requiredKbr id={element.id} idZaBtn={index} {...props} required />
        </CollapsableWrapper>
      );
    });

  const { auditCompanyBoardMember } = props.parentState.newFormData;
  const mappedAuditCompanyBoardMember = auditCompanyBoardMember.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`audit-company-board-collapse${index}`}
          clickText={`Član uprave ili upravnog odbora revizorskog društva ${
            element.ime && element.prezime ? `(${element.ime} ${element.prezime})` : "(Novi unos)"
          }`}
        >
          <AuditCompanyBoardMember
            requiredKbr
            id={element.id}
            idZaBtn={index}
            {...props}
            required
          />
        </CollapsableWrapper>
      );
    }
  );

  const { memberInfo } = props.parentState.newFormData;
  const mappedMemberInfo = memberInfo.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`member-info-${index}-collapse`}
        clickText={`Popis naziva i adresa društava članova i povezanih društava ${
          memberInfo.length > 1 ? `(${index + 1})` : ""
        }`}
      >
        <NamesAndAddressesNetworkList
          group={"memberInfo"}
          {...props}
          idZaBtn={index}
          id={element.id}
        />
      </CollapsableWrapper>
    );
  });

  const { supervisoryAuthority } = props.parentState.newFormData;
  const mappedWorkingSupervisoryAuthority = supervisoryAuthority.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`supervisory-authority-${index}-collapse`}
          clickText={`Nadležna tijela država članica odgovorna  za nadzor osiguranja kvalitete rada i nadzor ovlaštenih revizora i revizorskih društava
          ${supervisoryAuthority.length > 1 ? `(${index + 1})` : ""}`}
        >
          <NameAndAddressData
            onChange={props.mappedUserInputHandler}
            id={element.id}
            regId={"supervisory-auth"}
            idZaBtn={index}
            group={"supervisoryAuthority"}
            {...props}
          />
        </CollapsableWrapper>
      );
    }
  );

  const { auditCompanyRegistration } = props.parentState.newFormData;
  const mappedAuditCompanyRegistration = auditCompanyRegistration.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`audit-company-registration-collapse${index}`}
          clickText={`Registracije revizorskog društva kod nadležnog tijela drugih država članica ${
            auditCompanyRegistration.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            {...props}
            id={element.id}
            idZaBtn={index}
            regId={"audit-comp-reg-coll"}
            onChange={props.mappedUserInputHandler}
            inputValue={props.parentState.newFormData.auditCompanyRegistration}
            group="auditCompanyRegistration"
          />
        </CollapsableWrapper>
      );
    }
  );

  const { auditCompanyRegistrationForeign } = props.parentState.newFormData;
  const mappedAuditCompanyRegistrationForeign =
    auditCompanyRegistrationForeign.map((element, index) => {
      return (
        <CollapsableWrapper
          key={`audit-company-registration-foreign-collapse${index}`}
          clickText={`Registracije u drugoj državi članici revizorskog društva kao subjekt za obavljanje revizije u trećoj zemlji ${
            auditCompanyRegistrationForeign.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            {...props}
            id={element.id}
            idZaBtn={index}
            regId={"audit-comp-reg-foreign"}
            onChange={props.mappedUserInputHandler}
            inputValue={
              props.parentState.newFormData.auditCompanyRegistrationForeign
            }
            group="auditCompanyRegistrationForeign"
          />
        </CollapsableWrapper>
      );
    });

  return (
    <>
      <CollapsableWrapper clickText="Osnovni podaci">
        <Row>
          <Col>
            <InputComponent
              required
              disabled={
                props.parentState.newFormData.oznDokumenta.oznDokumenta !==
                  null &&
                props.parentState.update &&
                props.parentState.newFormData.userData.oznAkt == 1
              }
              style={
                props.parentState.error && userData.idBroj.length < 1 && "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "userData" }}
              value={userData.idBroj}
              id="idBroj"
              name="idBroj"
              controlLabel="Identifikacijski broj"
            />
          </Col>
          <Col>
            <InputComponent
              required
              style={
                props.parentState.error &&
                userData.nazDrustva.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "userData" }}
              value={userData.nazDrustva}
              id="nazDrustva"
              name="nazDrustva"
              controlLabel="Naziv društva/tvrtke"
            />
          </Col>
        </Row>
      </CollapsableWrapper>
      <CollapsableWrapper clickText="Adresa sjedišta">
        <BasicAddressData
          disableCro
          requiredNazNaselja
          hackId="hq-address"
          requiredKbr
          requiredBrPoste
          required
          objData={{ group: "hqAddress" }}
          address={hqAddress}
          onChange={props.userInputHandler}
          {...props}
        />
      </CollapsableWrapper>
      <CollapsableWrapper clickText="Podaci o poslovnoj adresi i registraciji u Hrvatskoj">
        <BasicAddressData
          hack
          hackId="cro-address"
          requiredNazNaselja
          requiredKbr
          requiredBrPoste
          required
          objData={{ group: "croAddress" }}
          address={croAddress}
          onChange={props.userInputHandler}
          {...props}
        />{" "}
        <Row>
          <Col>
            <DatepickerComponent
              errorBorderColor={
                props.parentState.error && userData.datReg.length < 1 && "red"
              }
              width={"100%"}
              required
              handleDayClick={props.handleDayClick}
              controlLabel={"Datum registracije"}
              value={userData.datReg}
              index={{ group: "userData", prop: "datReg" }}
            />
          </Col>
          <Col>
            {props.parentState.update && (
              <InputComponent
                disabled={props.parentState.update}
                style={
                  props.parentState.error &&
                  userData.regBroj.length < 1 &&
                  "red"
                }
                required
                onChange={props.userInputHandler}
                objData={{ group: "userData" }}
                value={userData.regBroj}
                id="regBroj"
                controlLabel="Broj registracije"
              />
            )}
          </Col>
        </Row>
      </CollapsableWrapper>
      <CollapsableWrapper clickText="Adresa i registracija kod nadležnog tijela matične države članice">
        <BasicAddressData
          required
          disableCro
          hackId="reg-address"
          objData={{ group: "registrationAddress" }}
          address={registrationAddress}
          onChange={props.userInputHandler}
          {...props}
        />
        <form className="dp-style-entry-form-5">
          <Row>
            <Col>
              <InputComponent
                style={
                  props.parentState.error &&
                  registrationAddress.nazTijela.length < 1 &&
                  "red"
                }
                required
                onChange={props.userInputHandler}
                objData={{ group: "registrationAddress" }}
                value={registrationAddress.nazTijela}
                id="nazTijela"
                name="nazTijela"
                controlLabel="Naziv nadležnog tijela"
              />
            </Col>
            <Col>
              <InputComponent
                style={
                  props.parentState.error &&
                  userData.brRegOrig.length < 1 &&
                  "red"
                }
                required
                onChange={props.userInputHandler}
                objData={{ group: "userData" }}
                value={userData.brRegOrig}
                id="brRegOrig"
                name="brRegOrig"
                controlLabel="Registarski broj"
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <InputComponent
                style={
                  props.parentState.error &&
                  registrationAddress.brReg.length < 1 &&
                  "red"
                }
                required
                onChange={props.userInputHandler}
                objData={{ group: "registrationAddress" }}
                value={registrationAddress.brReg}
                id="brReg"
                name="brReg"
                controlLabel="Broj odobrenja za rad"
              />
            </Col>
            <Col>
              <DatepickerComponent
                errorBorderColor={
                  props.parentState.error &&
                  registrationAddress.datReg.length < 1 &&
                  "red"
                }
                required
                handleDayClick={props.handleDayClick}
                controlLabel={"Datum odobrenja za rad"}
                width={"100%"}
                value={registrationAddress.datReg}
                index={{ group: "registrationAddress", prop: "datReg" }}
              />
            </Col>
          </Row>
          <Row>
            <ColDynamic className="col-lg-4 ">
              <Dropdown
                style={
                  props.parentState.error &&
                  userData.sifPOblika.length < 1 &&
                  "red"
                }
                label={"Pravni oblik*"}
                hidden
                onChange={props.pOblikDropdownHandler}
                value={userData.sifPOblika}
                asProperty="select"
                map={legalFormsOptions}
                text="Odaberite pravni oblik"
              />
            </ColDynamic>
            <Col>
              {userData.sifPOblika == "999" && (
                <InputComponent
                  style={
                    props.parentState.error &&
                    userData.sifPOblika == "999" &&
                    userData.opisPOblika.length < 1 &&
                    "red"
                  }
                  onChange={props.userInputHandler}
                  objData={{ group: "userData" }}
                  value={userData.opisPOblika}
                  id="opisPOblika"
                  name="opisPOblika"
                  controlLabel={"Opis pravnog oblika*"}
                />
              )}
            </Col>
          </Row>
        </form>
      </CollapsableWrapper>
      {getContactInfo}
      {mappedOfficeAddress}
      {mappedBasicReviserData}
      {mappedReviserRegistration}
      {mappedAuditCompanyMember}
      {mappedAuditCompanyBoardMember}
      <CollapsableWrapper clickText="Podaci o članstvu u mreži">
        <NetworkMembershipInfo required {...props} />
      </CollapsableWrapper>
      {mappedMemberInfo}
      {mappedAuditCompanyRegistration}
      {mappedAuditCompanyRegistrationForeign}
      {mappedWorkingSupervisoryAuthority}
      <div className="invert">
        {props.parentState.loader ? (
          <ButtonComponent disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Spremanje...
          </ButtonComponent>
        ) : (
          <ButtonComponent onClick={props.submitHandler}>
            {props.parentState.update ? "Spremi promjene" : "Unos u registar"}
          </ButtonComponent>
        )}
      </div>
    </>
  );
};

export default EntryForm5;
